// modules
import { createAction } from 'redux-actions'

// actions
export const setMedicalDeviceOrderingList = createAction(
  'SET_MEDICAL_DEVICE_ORDERING_LIST'
)
export const setMedicalDeviceOrderingEditOrder = createAction(
  'SET_MEDICAL_DEVICE_ORDERING_EDIT_ORDER'
)

export const setMedicalDeviceOrderingPatientAddresses = createAction(
  'SET_MEDICAL_DEVICE_ORDERING_PATIENT_ADDRESSES'
)
export const setMedicalDeviceOrderingPatientProfile = createAction(
  'SET_MEDICAL_DEVICE_ORDERING_PATIENT_PROFILE'
)
export const setMedicalDeviceOrderingTypeList = createAction(
  'SET_MEDICAL_DEVICE_ORDERING_TYPE_LIST'
)

export const resetMedicalDeviceOrdering = createAction(
  'RESET_MEDICAL_DEVICE_ORDERING'
)
